/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class testresults extends IceEntity {
  test_results_key: string = "";
  measurement_reference_id_code: string = "";
  measurement_qualifier: string = "";
  measurement_value: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
  return "TEST_RESULTS";
  }
}
